/** localStorage, or null where the page may not use it (private windows, sandboxed embeds). */
export function storage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
